import React, { useCallback, useState } from 'react';
import * as Styles from './MigrateAccountVpsDedicated.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
  Input,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale/useLocale';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';

export const MigrateAccountVpsDedicated = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const { migrateAccountVpsDedicated: migrateAccountVpsDedicatedLocale } = ticketsLocale.forms;
  const [formData, setFormData] = useState({
    ipOrDomain: '',
    user: '',
    password: '',
    detailedList: '',
    agreed: false,
  });

  const checkForm = useCallback(() => !(
    !!formData.ipOrDomain
    && !!formData.user
    && !!formData.password
    && !!formData.agreed
  ), [formData]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: ticketsLocale.forms.names.migrateAccountVpsDedicated,
      server_value: selectedProduct.serverhostname,
      domain_value: selectedProduct.domain,
      key: V2Forms.MIGRATE_ACCOUNT_VPS_DEDICATED,
      tags: [
        'whmcs_form_tecnico_migracion_vps_dedicado',
        selectedProduct.name.toLowerCase().replace(/ /g, '_'),
      ],
      body: `
      • ${migrateAccountVpsDedicatedLocale.body.product(selectedProduct)}
      • ${migrateAccountVpsDedicatedLocale.body.request}
      • ${migrateAccountVpsDedicatedLocale.body.ipOrDomain(formData.ipOrDomain)}
      • ${migrateAccountVpsDedicatedLocale.body.user(formData.user)}
      • ${migrateAccountVpsDedicatedLocale.body.password(formData.password)}
      • ${migrateAccountVpsDedicatedLocale.body.detailedList(formData.detailedList)}
      • ${migrateAccountVpsDedicatedLocale.body.agreed(formData.agreed)}
      • ${migrateAccountVpsDedicatedLocale.body.productId(selectedProduct)}
      `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    selectedProduct,
    formData,
    submitForm,
    migrateAccountVpsDedicatedLocale,
  ]);

  const handleChange = useCallback(({ key, value }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  }, [
    formData,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      <Styles.Info>
        <IconData />
        {migrateAccountVpsDedicatedLocale.info}
      </Styles.Info>

      <Styles.Title>
        {migrateAccountVpsDedicatedLocale.title}
      </Styles.Title>

      <Styles.InputsWrapper>
        <Input
          name="ipOrDomain"
          placeholder={migrateAccountVpsDedicatedLocale.placeholders.ipOrDomain}
          label={formData.ipOrDomain ? migrateAccountVpsDedicatedLocale.placeholders.ipOrDomain : ''}
          value={formData.ipOrDomain}
          onChange={e => handleChange({ key: 'ipOrDomain', value: e.target.value })}
          type="text"
          testId="ipOrDomain"
        />

        <Input
          name="user"
          placeholder={migrateAccountVpsDedicatedLocale.placeholders.user}
          label={formData.user ? migrateAccountVpsDedicatedLocale.placeholders.user : ''}
          value={formData.user}
          onChange={e => handleChange({ key: 'user', value: e.target.value })}
          type="text"
          testId="user"
        />

        <Input
          name="password"
          placeholder={migrateAccountVpsDedicatedLocale.placeholders.password}
          label={formData.password ? migrateAccountVpsDedicatedLocale.placeholders.password : ''}
          value={formData.password}
          onChange={e => handleChange({ key: 'password', value: e.target.value })}
          type="password"
          testId="password"
        />

        <Input
          name="detailedList"
          placeholder={migrateAccountVpsDedicatedLocale.placeholders.detailedList}
          label={formData.detailedList ? migrateAccountVpsDedicatedLocale.placeholders.detailedList : ''}
          value={formData.detailedList}
          onChange={e => handleChange({ key: 'detailedList', value: e.target.value })}
          type="textarea"
          rows={5}
          testId="detailedList"
        />
      </Styles.InputsWrapper>

      <Styles.CheckboxLabel
        htmlFor="#readTerms"
        data-testid="checkReadTerms"
        onClick={() => handleChange({ key: 'agreed', value: !formData.agreed })}
      >
        <Checkbox checked={formData.agreed} id="readTerms" />
        <Styles.Text>
          {migrateAccountVpsDedicatedLocale.placeholders.agreed}
        </Styles.Text>
      </Styles.CheckboxLabel>

      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : migrateAccountVpsDedicatedLocale.send}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default MigrateAccountVpsDedicated;
